import React, { useEffect } from 'react';
import { IconCheck, IconX, IconInfoCircle } from '@tabler/icons-react';
import styles from '../../pages/AdminDashboard.module.css';

export type NotificationType = 'success' | 'error' | 'info';

interface NotificationProps {
  type: NotificationType;
  message: string;
  onClose: () => void;
  autoCloseDelay?: number;
}

const Notification: React.FC<NotificationProps> = ({ 
  type, 
  message, 
  onClose,
  autoCloseDelay = 3000
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, autoCloseDelay);

    return () => {
      clearTimeout(timer);
    };
  }, [onClose, autoCloseDelay]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <IconCheck size={20} />;
      case 'error':
        return <IconX size={20} />;
      case 'info':
      default:
        return <IconInfoCircle size={20} />;
    }
  };

  return (
    <div className={`${styles.notification} ${styles[type]}`}>
      {getIcon()}
      <span>{message}</span>
    </div>
  );
};

export default Notification;
